

























import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';

@Component({
  name: 'catalog-product-list',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({default: 8}) private chunkSize: number;
  @Prop() private categoryId: number;

  private cmsBlockIndex: number = 5;

  private get isLoading(): boolean {
    return this.$store.getters[`${this.dataSource}/isLoading`];
  }

  private get products(): Array<object> {
    let categoryId = this.categoryId;

    if (this.$parent.$props.cmsBlock) {
      let products = [...this.$store.getters[`${this.dataSource}/productList`]];
      products.splice(this.cmsBlockIndex - 1, 0, this.$parent.$props.cmsBlock);
      return products;
    }

    let products = [...this.$store.getters[`${this.dataSource}/productList`]];

    let productSort =  products.sort(function (a, b) {
      return a[`category_${categoryId}_position`] - b[`category_${categoryId}_position`]
    });

    return productSort ? productSort : products;
  }

  private get dataLayerProducts(): Array<object> {
    const products = [...this.products];

    return products.map((product: object) => {
      return {
        ...product,
        'item_id': product['product_id'],
        'item_group_id': product['pim_productfamilie'] || product['product_id'],
        'item_variant': '',
        'item_variant_id': product['product_id'],
      };
    });
  }

  private get productChunks(): Array<object> {
    return Array.from({length: Math.ceil(this.products.length / this.chunkSize)}, (v, i) =>
      this.products.slice(i * this.chunkSize, i * this.chunkSize + this.chunkSize)
    );
  }

  @Watch('products')
  private productsHandler() {
    this.$store.dispatch('CatalogCategoryReviews/getProductReviews', {
      cacheKey: `${this.$parent['categoryId']}-${this.$parent['catalogData']['current_page']}`,
      productIds: this.products.map(product => product['external_id'] || 0)
    });
  }

  private created(): void {
    SolarDataLayer.init().addViewItemsList(this.dataLayerProducts, 'Product list');

    this.$store.dispatch('CatalogCategoryReviews/getProductReviews', {
      cacheKey: `${this.$parent['categoryId']}-${this.$parent['catalogData']['current_page']}`,
      productIds: this.products.map(product => product['external_id'] || 0)
    });
  }
  private updated(): void {
    this.$nextTick(() => {
      ('.catalog__category-list h3').matchHeight(true);
      ('.catalog__category-list .product__holder').matchHeight(true);
      const resizeEvent = new UIEvent('resize');
      window.dispatchEvent(resizeEvent);
    });
  }

}
